<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      show-save-button
      unit="考务信息"
      edit-title
      id-key="ExamId"
      :data="data"
      form-label-width="80px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="考点" prop="ExamPlace">
              <el-input v-model="data.ExamPlace" placeholder="请输入考点"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="人数" prop="StudentNumber">
              <!-- <el-select v-model="data.StudentNumber" allow-create filterable v-int placeholder="请输入人数">
                <el-option :value="30" />
                <el-option :value="32" />
                <el-option :value="40" />
                <el-option :value="50" />
                <el-option :value="60" />
              </el-select> -->
              <el-input v-model="data.StudentNumber" v-int placeholder="请输入人数"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="状态" prop="Status">
              <el-radio-group el-select v-model="data.Status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="注意事项" prop="Note">
              <el-input v-model="data.Note" type="textarea" rows="8" maxlength="250" show-word-limit placeholder="请输入注意事项"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="row-tb-head">
              <span>场次信息</span>
              <div style="float: right;">
                <el-button type="primary" icon="el-icon-plus" @click="addPlace">添加</el-button>
                <el-button type="danger" @click="delPlaces">删除</el-button>
              </div>
            </div>
            <el-table ref="tb_place" class="tb-c-head" :data="tableData" border>
              <el-table-column type="selection" width="40px" align="center" />
              <el-table-column label="时间" align="center">
                <template slot-scope="{row}">
                  <el-date-picker
                    v-model="row.StartTime"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    style="width: 47% !important;"
                    @change="change(row)"
                    placeholder="选择开始时间">
                  </el-date-picker>
                  -
                  <el-date-picker
                    v-model="row.EndTime"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    style="width: 47% !important;"
                    @change="change(row)"
                    placeholder="选择结束时间">
                  </el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="科目/内容" prop="Subject" width="200px" align="center">
                <template slot-scope="{row}">
                  <el-input v-model="row.Subject" @change="change(row)" placeholder="请输入科目/内容"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" fixed="right" width="80px">
                <template slot-scope="{row,$index}">
                  <el-button type="text" @click="delPlace(row,$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <div v-if="data.ExamId" style="margin: 12px 0 10px;">参加报名学生</div>
        <el-row v-if="data.ExamId">
          <el-col :span="24">
            <student-list ref="studentList">
              <template slot="toolbar-right">
                <el-button type="success" @click="toImport" plain>导入</el-button>
                <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
                <el-button type="danger" @click="delRows">删除</el-button>
              </template>
              <template slot="column">
                <el-table-column label="操作" fixed="right" align="center" width="60">
                  <template slot-scope="{ row }">
                    <el-button type="text" @click="edit(row)" title="编辑" icon="el-icon-edit"></el-button>
                  </template>
                </el-table-column>
              </template>
            </student-list>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <option-dialog ref="optionDialog" @close-saved="reload" :exam-id="data.ExamId" :type="data.EnrollType" />
    <import-dialog ref="importDialog" @upload-success="reload" :exam-id="data.ExamId" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import studentList from './studentList';
import optionDialog from "./optionDialog";
import importDialog from "./importDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    studentList,
    optionDialog,
    importDialog
  },
  data() {
    return {
      data: {
        ExamId: 0,
        ExamPlace: "",
        EnrollType: 1,
        StudentNumber: null,
        Status: 1,
        Note: "",
        Sesstions: [],
      },
      tableData: [],
      delList: [],
      isMB: this.$store.state.isMB,
      api: require("@/api/po/exam").default,
      rules: {
        ExamPlace: [{ required: true, message: "考点不能为空" }],
        // EnrollType: [{ required: true, message: "报考类型不能为空" }],
        StudentNumber: [{ required: true, message: "人数不能为空" }],
      },
    };
  },
  methods: {
    onCreateOpened() {
    },
    onEditOpened(data) {
      data.Sesstions.forEach(e => {
        delete e.T;
      })
      this.tableData = data.Sesstions;
      this.$refs.studentList.getData({ ExamId: data.ExamId });
    },
    addPlace() {
      this.tableData.push({
        T: 0,
        ExamSessionId: 0,
        ExamId: this.data.ExamId,
        StartTime: "",
        EndTime: "",
        Subject: "",
      })
    },
    change(row) {
      if(!(row.T === 0)) {
        row.T = 1;
      }
    },
    delPlace(row,index) {
      if(!(row.T===0)) {
        row.T = 2;
        this.delList.push(row);
      }
      this.tableData.splice(index,1);
    },
    delPlaces() {
      var rows = this.$refs.tb_place.selection;
      if(rows.length==0) {
        this.$message.error("请选择要删除的数据");
        return;
      }
      var ids = rows.map(x => x.ExamSessionId);
      ids.forEach(e => {
        var obj = this.tableData.find(x => x.ExamSessionId == e);
        var index = this.tableData.findIndex(x => x.ExamSessionId == e);
        if(index > -1) {
          this.delPlace(obj,index);
        }
      })
    },
    onBeforeSave() {
      var td = this.tableData;
      if(td.length == 0) {
        this.$message.error("请添加场次信息");
        return false;
      }
      var dl = this.delList;
      var to = [];
      for (let i = 0; i < td.length; i++) {
        const e = td[i];
        if(!e.StartTime || !e.EndTime) {
          this.$message.error("请选择时间");
          return false;
        }
        var start = this.$commonJs.toDateString(e.StartTime);
        var end = this.$commonJs.toDateString(e.EndTime);
        if(start != end) {
          this.$message.error("场次信息-开始结束时间须在同一天");
          return false;
        }
        var st = (new Date(e.StartTime)).getTime();
        var et = (new Date(e.EndTime)).getTime();
        if(st > et) {
          this.$message.error("场次信息-时间范围不正确");
          return false;
        }
        if(!e.Subject) {
          this.$message.error("请输入科目/内容");
          return false;
        }
        if(e.T === 0 || e.T === 1) {
          to.push(e);
        }
      }
      this.data.Sesstions = to.concat(dl);
    },
    onClosed() {
      this.tableData = [];
      this.delList = [];
    },
    //---------------------------------
    reload() {
      this.$refs.studentList.reload();
    },
    create() {
      this.$refs.optionDialog.openCreate();
    },
    edit(row) {
      this.$refs.optionDialog.openEdit(row);
    },
    toImport() {
      this.$refs.importDialog.open();
    },
    delRows() {
      let rows = this.$refs.studentList.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.ExamStudentId;
          });
          this.$refs.studentList.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>